<template>
  <main id="news" class="detail">
    <section id="newsdetail" class="livenex--inner">
      <dl>
        <dd>{{ alertInfo.alertTitle }}</dd>
        <small>登録日：{{ alertInfo.alertDateStr }}</small>
      </dl>
      <div>
        <p>{{ alertInfo.alertMessage }}</p>
      </div>
      <a class="btn__common typeBlack" @click="$emit('move-destination')"
        >{{ pageName }}へ</a
      >
    </section>
  </main>
</template>
<script>
export default {
  props: {
    alertInfo: {}
  },
  computed: {
    pageName: function() {
      if (
        this.alertInfo.destinationName &&
        ~this.alertInfo.destinationName.indexOf("financing-plan")
      ) {
        return "資金計画";
      } else if (
        this.alertInfo.destinationName &&
        ~this.alertInfo.destinationName.indexOf("saved-plan/detail")
      ) {
        return "マイページ";
      } else {
        return "マイページ";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
section {
  text-align: left !important;
}
main#news section#newsdetail .btn__common {
  margin: 30px auto;
}
p {
  white-space: pre-line;
}
main {
  padding-bottom: 0px !important;
}
@media screen and (max-width: 900px) {
  main {
    padding-bottom: 0px !important;
  }
  main#news section#newsdetail .btn__common {
    margin: 15px auto;
  }
}
</style>
